import axios from 'axios';
import wx from 'weixin-js-sdk';
import config from './config';

(function () {
  const signUrl = window.location.href;
  setTimeout(() => {
    axios.post(config.wxSignUrl, {
      url: signUrl,
    }).then((response) => {
      const res = response.data;
      wx.config({
        debug: false,
        jsApiList: [
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
        ],
        ...res.data,
      });
    });
  }, 100); 
})();